import { Panel as BasePanel } from '../smart_bps/lib/components'
import classNames from 'classnames'

export class Panel extends BasePanel {
  constructor(props) {
    super(props)
  }

  render() {
    const props = this.props
    const bodyShow = this.state.show
    const lazyContent = props.lazyContent

    const iconClass = classNames("tf-icons ti scaleX-n1-rtl ti-sm", {
      "ti-chevron-down": bodyShow,
      "ti-chevron-left": !bodyShow,
    })

    let cardBody = null;

    if (bodyShow) {
      if (props.noWrapBody) {
        cardBody = props.children || lazyContent()
      }
      else {
        cardBody = <div className="card-body p-3">
          {props.children || lazyContent()}
        </div>
      }
    }
    if (this.props.header === 'События по документу') {
      return (
        <div className="card card-action mb-3">
          {props.header && (
            <div className="card-header text-decoration-none py-2 px-3">
              <p className="mb-0">{props.header}</p>
              <div className="card-action-element">
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <span className="card-collapsible pointer" onClick={this.toggleShow}>
                      <i className={iconClass}></i>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          )}
          <div className="collapse show">
            {cardBody}
          </div>
        </div>
      )
    }
    return super.render()
  }
}